import { useQuery } from 'react-query'
import { getOrderHistory } from '../../services/api'

export function useGetOrderHistoryIndex() {
  return useQuery('orderHistoryIndex', getOrderHistory)
}
